export default "__VITE_ASSET__DPpB0rcT__"